import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { themeConfig } from './config/themeConfig.jsx'
import { ConfigProvider } from "antd";
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/authContext.jsx'
import { App as AntdApp } from 'antd';
import { unstableSetRender } from 'antd';
import { Provider } from 'react-redux'
import store from './store/store.jsx'
import { setAxiosInterceptors } from './service/axiosInterceptors.jsx'
import { ScreenProvider } from './context/ScreenContext.jsx'

unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

setAxiosInterceptors();
createRoot(document.getElementById('root')).render(
  <ScreenProvider>
    <AuthProvider>
      <BrowserRouter>
        <ConfigProvider
          componentSize="large"
          theme={themeConfig}>
          <AntdApp>
            <Provider store={store}>
              <App />
            </Provider>
          </AntdApp>
        </ConfigProvider>
      </BrowserRouter>
    </AuthProvider>
  </ScreenProvider>

)
